import { useParams, useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import { TIER_ORDER, TIER_LABELS } from '../../config/house.config';
import type { SupportedLang } from '../../config/house.config';

export default function ArchiveDetailPage() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const item = useStore(s => s.archive_items.find(a => a.slug === slug && !a.deleted_at));
  const member = useStore(s => s.getMember());
  const lang = i18n.language as SupportedLang;

  if (!item) {
    return (
      <div className="text-center py-12 space-y-4">
        <p className="font-serif text-xl text-charcoal/50">{t('common.notFound')}</p>
        <Link to="/archive" className="text-[11px] tracking-widest uppercase font-sans text-charcoal/40 hover:text-charcoal">{t('common.backList')} →</Link>
      </div>
    );
  }

  const tr = item.translations[lang] || item.translations.en;
  const tierIdx = member ? TIER_ORDER.indexOf(member.access_tier) : -1;
  const unlocked = TIER_ORDER.indexOf(item.min_tier) <= tierIdx;

  if (!unlocked) {
    return (
      <div className="max-w-2xl space-y-6">
        <button onClick={() => navigate('/archive')} className="text-[10px] tracking-widest uppercase font-sans text-charcoal/30 hover:text-charcoal">← {t('common.backList')}</button>
        <h1 className="font-serif text-3xl">{tr.title}</h1>
        <div className="border border-charcoal/10 p-8 text-center space-y-3">
          <p className="text-[10px] tracking-widest-xl uppercase text-gold font-sans">🔒 {TIER_LABELS[item.min_tier]}</p>
          <button onClick={() => navigate('/membership')} className="text-[11px] tracking-widest uppercase font-sans border-b border-charcoal/20 pb-0.5 hover:border-charcoal">{t('nav.membership')} →</button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl space-y-6">
      <button onClick={() => navigate('/archive')} className="text-[10px] tracking-widest uppercase font-sans text-charcoal/30 hover:text-charcoal">← {t('common.backList')}</button>
      <p className="text-[10px] tracking-widest uppercase text-charcoal/20 font-sans">{item.house_category_slug}</p>
      <h1 className="font-serif text-3xl">{tr.title}</h1>
      <p className="text-sm font-sans text-charcoal/70 leading-relaxed whitespace-pre-line">{tr.content}</p>
    </div>
  );
}
